import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';

//import components
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';
import NewsMenu from '../components/news/NewsMenu.js';
import NewsSearch from '../components/news/NewsSearch.js';
import NewsSubpage from '../components/news/NewsSubpage.js';
import Error404Page from '../components/Error404Page.js';

import menuItems from '../scripts/NewsSubpages.js';
import withTitle from '../scripts/WithTitle.js';

class News extends Component {
    constructor() {
        super();

        this.state = {
            searchValue: '',
        };
    };

    componentDidMount() {
        const { actions, clang, match } = this.props;
        actions.getNewsSubpage(match.params.type, clang);
        actions.getNewsSubpageCategory(match.params.type, clang);
    };

    componentDidUpdate(prevProps, prevState) {
        const { actions, clang, match } = this.props;

        if (clang !== prevProps.clang || match.params.type !== prevProps.match.params.type) {
            this.setState({searchValue: ''});
            actions.getNewsSubpage(match.params.type, clang);
            actions.getNewsSubpageCategory(match.params.type, clang);
        }
    };

    componentWillUnmount() {
        this.setState({searchValue: ''});
    };

    setActiveSubpage = (id) => {
        const { actions, clang } = this.props;

        this.setState({searchValue: ''});
        actions.getNewsSubpage(id, clang);
        actions.getNewsSubpageCategory(id, clang);
    };

    searchNews = (value) => {
        this.setState({searchValue: value});
    };

    breadcrumbsList = [{label: 'home'}, {label: 'news', link: '/news'}];

    render() {
        const { match, pageData, pageDataCategory, isLoadingError, isFetching, clang, location} = this.props;
        const { searchValue } = this.state;
        if (!menuItems.map(item => item.name).includes(match.params.type)) {
            return (
                <Error404Page location={location}/>
            );
        }
        const filteredPageData = pageData && pageData.filter(dataItem => dataItem.title.rendered.toLowerCase().includes(searchValue.toLowerCase().trim()));
        return (
            <section className="news">
                <ItemBreadcrumbs list={this.breadcrumbsList} currentPage={lang[clang].news[match.params.type]}/>

                <div className="news__container">
                    <aside className="news__menu-container">
                        <NewsSearch searchNews={this.searchNews} isPageData={pageData}/>
                        <NewsMenu items={menuItems} />
                    </aside>

                    <NewsSubpage
                        searchValue={searchValue}
                        isFetching={isFetching}
                        id={match.params.type}
                        isLoadingError={isLoadingError}
                        pageData={filteredPageData}
                        pageDataCategory={pageDataCategory}/>
                </div>
            </section>
        );
    };
};

News.propTypes = {
    clang: propTypes.string.isRequired,
    actions: propTypes.object.isRequired,
    pageData: propTypes.array,
    pageDataCategory: propTypes.array,
    isFetching: propTypes.bool.isRequired,
    isLoadingError: propTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    pageData: state.news.pageData,
    pageDataCategory: state.news.pageDataCategory,
    isFetching: state.news.isFetching,
    isLoadingError: state.news.isLoadingError,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(News);



// WEBPACK FOOTER //
// ./src/containers/News.js